
export enum NativePluginEventName {
	ReceiveBarcode = 'receiveBarcode',
	ReceiveSelectedProducts = 'receiveSelectedProducts',
}

export type NativePluginEventListenerHandler = (data: any) => void

export type NativePluginEventListenerRemover = () => void
